import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { IsEmail, Length, Matches } from 'class-validator';
import { ToLowerCase } from '../../common/utils';
import { UserExposeGroup } from '../interface/UserExposeGroup';
export class CreateUserDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [
            UserExposeGroup.FIXTURE,
            UserExposeGroup.READ,
            UserExposeGroup.INVITE_EMAIL,
            UserExposeGroup.CREATE,
            UserExposeGroup.CREATE_SSO,
            UserExposeGroup.RESET_PASSWORD,
        ],
    }),
    IsEmail({}, { groups: [UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.CREATE_SSO, UserExposeGroup.INVITE_EMAIL, UserExposeGroup.RESET_PASSWORD] }),
    ToLowerCase(),
    __metadata("design:type", String)
], CreateUserDto.prototype, "email", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [UserExposeGroup.FIXTURE, UserExposeGroup.INVITE_EMAIL_CONFIRM, UserExposeGroup.CREATE, UserExposeGroup.RESET_PASSWORD_CONFIRM],
    }),
    Length(8, 255, { groups: [] }),
    Matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/, {
        groups: [UserExposeGroup.CREATE, UserExposeGroup.CREATE_PHONE, UserExposeGroup.INVITE_EMAIL_CONFIRM, UserExposeGroup.RESET_PASSWORD_CONFIRM],
        message: 'Password should contain a-z A-Z 0-9',
    }),
    __metadata("design:type", String)
], CreateUserDto.prototype, "password", void 0);
//# sourceMappingURL=CreateUserDto.js.map